import { useEffect, useState } from 'react';
import TRCLessonsSection from './sections/Lessons';
import TRCProgressiveLessonsSection from './sections/ProgressiveLessons';
import TRCResourcesSection from './sections/Resources';
import TRCVideosSection from './sections/Videos';
import api from '../../../data/api';
import Toast from '../../../utils/toastManager';
import TRC_PAGE_CATEGORIES from '@/TRC/constants/trcCategories';
import { useAtomValue } from 'jotai';
import { userInfoAtom } from '@/data/atoms/utilsAtoms';
import { getStudioHubBannerSrc, isStudioUser } from '@/utils/isStudioUser';

const getCreatedAtTime = item => {
	const time = new Date(item?.createdAt || item?.updatedAt || 0).getTime();
	return Number.isNaN(time) ? 0 : time;
};

const sortNewestFirst = contents =>
	[...(contents || [])].sort((a, b) => getCreatedAtTime(b) - getCreatedAtTime(a));

const TRCHome = () => {
	const [lessonPlans, setLessonPlans] = useState([]);
	const [progressiveLessonPlans, setProgressiveLessonPlans] = useState([]);
	const [videos, setVideos] = useState([]);
	const [resources, setResources] = useState([]);
	const userData = useAtomValue(userInfoAtom);
	const isStudioHub = isStudioUser(userData);
	const bannerSrc = getStudioHubBannerSrc(userData);

	async function fetchContent() {
		try {
			const [contentResponse, progressiveLessonPlanResponse] = await Promise.all([
				api.fetchContent(),
				isStudioHub ? api.getLessonPlans() : Promise.resolve({ data: [] })
			]);
			const data = contentResponse?.data || [];

			const sortedData = sortNewestFirst(data);

			const lessonPlans = sortedData.filter(item =>
				item.categoryDetails?.some(cat => cat.name?.toUpperCase() === TRC_PAGE_CATEGORIES.LESSON_PLANS)
			);

			const videos = sortedData.filter(item =>
				item.categoryDetails?.some(cat => cat.name?.toUpperCase() === TRC_PAGE_CATEGORIES.VIDEOS)
			);

			const resources = sortedData.filter(item =>
				item.categoryDetails?.some(cat => cat.name?.toUpperCase() === TRC_PAGE_CATEGORIES.RESOURCES)
			);

			setLessonPlans(lessonPlans);
			setProgressiveLessonPlans(progressiveLessonPlanResponse?.data || []);
			setVideos(videos);
			setResources(resources);
		} catch (err) {
			Toast.error(err.message || 'Failed to fetch content');
		}
	}

	useEffect(() => {
		fetchContent();
	}, [isStudioHub]);

	return (
		<div className="d-flex flex-column gap-2" style={{ background: '#171718', paddingBottom: '10rem' }}>
			<div className="c-banner-img">
				<img
					src={bannerSrc}
					width="1450"
					height="420"
					alt={isStudioHub ? 'Studio Hub banner' : 'Teacher Resource Center banner'}
				/>
			</div>
			{isStudioHub ? (
				<TRCProgressiveLessonsSection lessonPlans={lessonPlans} progressiveLessonPlans={progressiveLessonPlans} />
			) : (
				<TRCLessonsSection lessonPlans={lessonPlans} />
			)}
			<TRCVideosSection videos={videos} />
			<TRCResourcesSection resources={resources} />
		</div>
	);
};

export default TRCHome;
